var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2698 10.702H12.2048C11.9397 10.702 11.7236 10.9181 11.7236 11.1831C11.7236 11.3181 11.781 11.4397 11.8705 11.5274L16.1411 15.7981C16.2289 15.8926 16.3556 15.9518 16.494 15.9518C16.6611 15.9518 16.8079 15.8673 16.894 15.739C17.944 14.5203 18.6192 12.9724 18.7408 11.2691C18.7475 11.2405 18.7509 11.2118 18.7509 11.183C18.7509 10.9181 18.5365 10.702 18.2698 10.702Z",
    fill: "#8F8C9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3704 1.98334C10.1053 1.98496 9.89099 2.1994 9.89099 2.46441V9.20468C9.89099 9.47142 10.1053 9.68748 10.3704 9.68748H17.1124C17.3775 9.68748 17.5935 9.47142 17.5935 9.20468C17.3554 5.32568 14.2511 2.22139 10.3704 1.98334Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0773 15.4049L9.10442 10.432C9.02005 10.3459 8.96943 10.226 8.96943 10.096L8.96765 3.07211C8.96765 2.80711 8.75331 2.59271 8.48825 2.59271C4.44882 2.83919 1.25 6.19493 1.25 10.2952C1.25 14.5575 4.70545 18.0146 8.96765 18.0146C10.9123 18.0146 12.6881 17.2955 14.0452 16.1087C14.1499 16.0209 14.2158 15.8893 14.2158 15.7425C14.2158 15.6124 14.1634 15.4926 14.0773 15.4049Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.992ef7528be0c89d5d8edc4ef4eadbbf.svg";
export { ForwardRef as ReactComponent };